import API_BASE_URL from "../utils/config";
import request from "../utils/request";

// this end point will communicate with the Ai to generate the soultion of provided questions
export async function postSolutionToAi(data) {
  const url = `${API_BASE_URL}/solutions/generate`;
  return request({
    url,
    method: "post",
    data,
  });
}

export async function httpMarkAnswer(data) {
  const url = `${API_BASE_URL}/solutions/answer`;
  return request({
    url,
    method: "post",
    data,
  });
}
